import React, { useEffect, useState } from "react";
import "./App.css";
import SendNotification from "./components/SendNotification";
import Login from "./views/login";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useParams,
} from "react-router-dom";
import { Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectState } from "./store/slices/authSlice";
import { selectState as selectThemeState, selectBusinessTheme } from "./store/slices/themeSlice";
import GenerateReferralCode from "./views/accessCodes/accessCodesForm";
import AddToWaitlist from "./components/AddToWaitlist";
import Dashboard from "./views/dashboard";
import Layout from "./views/layout";
import AddContractForm from "./views/Contract/contracts";
import AccessCodes from "./views/accessCodes/accessCodes";
import GenerateLicences from "./views/accessCodes/licenceCodeForm";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AccessCode from "./views/accessCodes/accessCode";
import { AppDispatch, RootState } from "./store/store";
import { AccessCodeType } from "./store/actions/accessCodeActions";
import Clients from "./views/clients/clients";
import Advisors from "./views/advisors/advisors";
import AdvisorDetails from "./views/advisors/advisorDetails";
import ClientDetails2 from "./views/clients/clientDetails2";
import UpdatePassword from "./views/updatePassword";
import ProfileView from "./views/profileView";
import AutoLogout from "./components/AutoLogout";
import ContractDetails from "./views/Contract/ContractDetails";
import ReferralsCodes from "./views/Referrals/ReferralsCodes";
import ReferralCodeDetails from "./views/Referrals/ReferralCodeDetails";
import NewContract from "./views/Contract/NewContract";
import FinancialInstitutions from "./views/financialInstitutions/FinancialInstitutions";
import FinancialInstitutionsDetails from "./views/financialInstitutions/FinancialInstitutionsDetails";
import ErrorsScreen from "./views/errorsMangment/errorsScreen";
import ErrorsScreenDetails from "./views/errorsMangment/errorsScreenDetails";
import { BulkUploadClientIds } from "./components/BulkUploadClientIds";
import InviteDispatch from "./views/oveview/InviteDispatch";
import SendInvitation from "./views/oveview/SendInvitation";
import WhiteLabelingForm from "./views/WhiteLabel/WhiteLablingForm";
import ImportJsonTheme from "./views/WhiteLabel/ImportJsonTheme";
import BusinessDetails from "./views/WhiteLabel/businessDetails";
import { getDashboardTheme } from "./store/actions/businessActions";
import BusinessDetailsTabs from "./views/WhiteLabel/BusinessDetailsTabs";
import V2Playground from "./views/v2Playground/V2Playground";

const AccessCodeWrapper = () => {
  const { id } = useParams(); // Extract `id` from URL
  const [accessCode, setAccessCode] = useState<AccessCodeType | undefined>();
  const { accessCodes } = useSelector(
    (state: RootState) => state.accessCode_slice,
  );
  useEffect(() => {
    if (id) {
      setAccessCode(accessCodes?.filter((item) => item.id == id)[0]);
    }
  }, [id]);

  // Ensure the access code is loaded before rendering
  if (!accessCode) return <div>Loading...</div>;

  return <AccessCode accessCode={accessCode} />;
};
interface ProtectedRouteProps {
  element: JSX.Element;
  isAuthenticated: boolean;
}

function ProtectedRoute({ element, isAuthenticated }: ProtectedRouteProps) {
  return isAuthenticated ? element : <Navigate to="/login" />;
}
interface AdminRouteProps {
  element: JSX.Element;
}

const AdminRoute = ({ element }: AdminRouteProps) => {
  const { isAuthenticated, user } = useSelector(selectState);

  // Check if the user is authenticated and if the business name is 'elisyan'
  const isAdmin = isAuthenticated && user?.business?.name === "elisyan";

  return isAdmin ? element : <Navigate to="/" />;
};
const AdminProtectedRoute = ({ element }: AdminRouteProps) => {
  const { isAuthenticated, user } = useSelector(selectState);

  // Check if the user is authenticated and if the business name is 'elisyan'

  const isAdmin =
    isAuthenticated &&
    (user?.business?.name === "elisyan" ||
      user?.business?.name === "sopher" ||
      user?.business?.name === "OLYMPE" ||
      user?.business?.name === "sopher-test");

  return isAdmin ? element : <Navigate to="/" />;
};

// In your src/index.js or src/App.js (at the very top)
if (process.env.NODE_ENV === 'production'
) {
  console.log = () => {};
  console.error = () => {};
  console.warn = () => {};
  console.info = () => {};
  console.debug = () => {};
  console.table = () => {};
  console.time = () => {};
  console.timeEnd = () => {};
  console.group = () => {};
  console.groupEnd = () => {};
}
const App = () => {
  const { isAuthenticated } = useSelector(selectState);
  const { activeTheme, mode, theme , businessClientCode,
    businessThemeVersion} = useSelector(selectThemeState);
  const dispatch = useDispatch<AppDispatch>();
  // NEW: Business theme state - simple and clean
  const businessTheme = useSelector(selectBusinessTheme);
  
  // Load theme on mount
  useEffect(() => {
      if(!businessClientCode) return;
      dispatch(getDashboardTheme({ clientCode: businessClientCode || undefined , version: businessThemeVersion  }));
    
  }, []);

  // useEffect(() => {
  //   console.log('business theme::::::', businessTheme);
  //   console.log('active theme', activeTheme,'mode', mode);
  // },[businessTheme]);
    
  return (
    <>
      <AutoLogout />
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <ProtectedRoute
                element={
                  <Layout>
                    <Dashboard />
                  </Layout>
                }
                isAuthenticated={isAuthenticated}
              />
            }
          />
          <Route
            path="/changePassword"
            element={
              <ProtectedRoute
                element={
                  <Layout>
                    <UpdatePassword />
                  </Layout>
                }
                isAuthenticated={isAuthenticated}
              />
            }
          />
          <Route
            path="/uploadClientIds"
            element={
              <ProtectedRoute
                element={
                  <Layout>
                    <BulkUploadClientIds />
                  </Layout>
                }
                isAuthenticated={isAuthenticated}
              />
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute
                element={
                  <Layout>
                    <ProfileView />
                  </Layout>
                }
                isAuthenticated={isAuthenticated}
              />
            }
          />
          <Route
            path="/contracts"
            element={
              <AdminRoute
                element={
                  <Layout>
                    <AddContractForm />
                  </Layout>
                }
              />
            }
          />
          <Route
            path="/contractDetails"
            element={
              <AdminRoute
                element={
                  <Layout>
                    <ContractDetails />
                  </Layout>
                }
              />
            }
          />
          <Route
            path="/inviteDispatch"
            element={
              <AdminRoute
                element={
                  <Layout>
                    <InviteDispatch />
                  </Layout>
                }
                // isAuthenticated={isAuthenticated}
              />
            }
          />

          <Route
            path="/sendInvitation"
            element={
              <AdminRoute
                element={
                  <Layout>
                    <SendInvitation />
                  </Layout>
                }
              />
            }
          />

          <Route
            path="/addNewContract"
            element={
              <AdminRoute
                element={
                  <Layout>
                    <NewContract />
                  </Layout>
                }
              />
            }
          />
          <Route
            path="/ReferralsCodes"
            element={
              <AdminRoute
                element={
                  <Layout>
                    <ReferralsCodes />
                  </Layout>
                }
              />
            }
          />
          <Route
            path="/referralCodeDetails"
            element={
              <AdminRoute
                element={
                  <Layout>
                    <ReferralCodeDetails />
                  </Layout>
                }
              />
            }
          />
          <Route
            path="/addToWaitlist"
            element={
              <ProtectedRoute
                element={
                  <Layout>
                    <AddToWaitlist />
                  </Layout>
                }
                isAuthenticated={isAuthenticated}
              />
            }
          />
          <Route path="/login" element={<Login />} />
          <Route
            path="/sendNotification"
            element={
              <ProtectedRoute
                element={
                  <Layout>
                    <SendNotification />
                  </Layout>
                }
                isAuthenticated={isAuthenticated}
              />
            }
          />
          <Route
            path="/generateReferalCode"
            element={
              <AdminRoute
                element={
                  <Layout>
                    <GenerateReferralCode />
                  </Layout>
                }
              />
            }
          />
          <Route
            path="/accessCodes"
            element={
              <ProtectedRoute
                element={
                  <Layout>
                    <AccessCodes />
                  </Layout>
                }
                isAuthenticated={isAuthenticated}
              />
            }
          />
          <Route
            path="/accessCode/:id"
            element={
              <ProtectedRoute
                element={
                  <Layout>
                    <AccessCodeWrapper />
                  </Layout>
                }
                isAuthenticated={isAuthenticated}
              />
            }
          />
          <Route
            path="/clients"
            element={
              <ProtectedRoute
                element={
                  <Layout>
                    <Clients />
                  </Layout>
                }
                isAuthenticated={isAuthenticated}
              />
            }
          />
          <Route
            path="/advisors"
            element={
              <AdminProtectedRoute
                element={
                  <Layout>
                    <Advisors />
                  </Layout>
                }
              />
            }
          />
          <Route
            path="/clientDetails"
            element={
              <ProtectedRoute
                element={
                  <Layout>
                    <ClientDetails2 />
                  </Layout>
                }
                isAuthenticated={isAuthenticated}
              />
            }
          />
          <Route
            path="/advisorDetails"
            element={
              <ProtectedRoute
                element={
                  <Layout>
                    <AdvisorDetails />
                  </Layout>
                }
                isAuthenticated={isAuthenticated}
              />
            }
          />
          <Route
            path="/generateLicence"
            element={
              <ProtectedRoute
                element={
                  <Layout>
                    <GenerateLicences />
                  </Layout>
                }
                isAuthenticated={isAuthenticated}
              />
            }
          />
          <Route
            path="/financialInstitutions"
            element={
              <AdminRoute
                element={
                  <Layout>
                    <FinancialInstitutions />
                  </Layout>
                }
              />
            }
          />
          <Route
            path="/errors"
            element={
              <AdminRoute
                element={
                  <Layout>
                    <ErrorsScreen />
                  </Layout>
                }
              />
            }
          />
          <Route
            path="/errorsDetails"
            element={
              <AdminRoute
                element={
                  <Layout>
                    <ErrorsScreenDetails />
                  </Layout>
                }
              />
            }
          />
          <Route
            path="/financialInstitutionsDetails"
            element={
              <AdminRoute
                element={
                  <Layout>
                    <FinancialInstitutionsDetails />
                  </Layout>
                }
              />
            }
          />
          <Route
            path="/addNewWhiteLabel"
            element={
              <AdminRoute
                element={
                  <Layout>
                    <WhiteLabelingForm />
                  </Layout>
                }
              />
            }
          />
          <Route
            path="/businesses/:id"
            element={
              <AdminRoute
                element={
                  <Layout>
                    <BusinessDetailsTabs />
                  </Layout>
                }
              />
            }
          />
          <Route
            path="/importJsonTheme"
            element={
              <AdminRoute
                element={
                  <Layout>
                    <ImportJsonTheme />
                  </Layout>
                }
              />
            }
          />
          ImportJsonTheme
          <Route
            path="/v2-playground"
            element={
              <AdminRoute
                element={
                  <Layout>
                    <V2Playground />
                  </Layout>
                }
              />
            }
          />
        </Routes>
      </Router>
      {/* Add ToastContainer to render notifications */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        toastStyle={
          {
            // backgroundColor: '#333', // Default background color for all toasts
            //color: '#fff', // Default text color for all toasts
          }
        }
        progressStyle={{
          backgroundColor: "#6B7A8E", // Customize progress bar color (default blue)
        }}
      />
    </>
  );
};

export default App;
